
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2r0OO", function(module, exports) {
/* CwrWelcomeBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");




const $113daf0dd7ff69a1$export$631cbd1d869e1777 = (0, $aXWIB.defineMessages)({
    bannerWelcomeMessage: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.heading",
        defaultMessage: "Welcome to Confluence"
    },
    bannerWelcomeMessageWithName: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.heading.with-name",
        defaultMessage: "Welcome to Confluence, {firstName}"
    },
    bannerPersonalSpaceSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.personal-space.subtext",
        defaultMessage: "Use Confluence to create and share knowledge with your team. This is your personal space, a private area just for your own work and ideas."
    },
    bannerSharedSpaceSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.shared-space.subtext",
        defaultMessage: "You've landed in a Confluence space. Use this area to build project plans, team handbooks, and anything else you want to share with the team."
    },
    bannerLiveDocSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.live-doc.subtext",
        defaultMessage: "Use Confluence to create and share knowledge with your team. This is your personal space, a private area just for your own work and ideas."
    },
    bannerHomeSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.home.subtext",
        defaultMessage: "Use Confluence to create and share knowledge with your team. This is your Home page, a personalized view of the latest updates from your team."
    },
    bannerDismissLabel: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.dismiss",
        defaultMessage: "Dismiss banner"
    }
});


var $af279cb6748794c3$exports = {};
$af279cb6748794c3$exports = new URL("LightWelcomeImage.b703b601.png", import.meta.url).toString();


var $b3fc91056516881a$exports = {};
$b3fc91056516881a$exports = new URL("DarkWelcomeImage.ebbc9b04.png", import.meta.url).toString();


const $57d88de957aaaec2$export$cc62c17e0857f7f7 = 'cwrWelcome';
const $57d88de957aaaec2$var$CWR_WELCOME_VARIANTS = [
    'personalSpace',
    'sharedSpace',
    'liveDoc',
    'home'
];
const $57d88de957aaaec2$var$isCwrWelcomeVariant = (value)=>!!value && $57d88de957aaaec2$var$CWR_WELCOME_VARIANTS.includes(value);
const $57d88de957aaaec2$var$useCwrWelcomeParam = (0, $dPJCf.createSingleQueryParamHook)($57d88de957aaaec2$export$cc62c17e0857f7f7);
const $57d88de957aaaec2$var$unboundedStyles = {
    root: "_1reo15vq _18m915vq _18zroahv _x3doia51 _n7zlia51 _1bsb5xur _18u09b24 _bfhk1s93 _4t3i1j4a _kqswh2mm",
    headingStyles: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjkb7n _sudp1e54",
    subtextStyles: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjcs5v _sudp1e54",
    livePageStyle: "_x3doglyw _18u0ze3t _1bsb1wug"
};
const $57d88de957aaaec2$var$styles = {
    contentContainerStyles: "_zulpu2gc _1yt41ejb _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _1pbykb7n _1bsb1nrf",
    svgContainer: "_1bsbhwvj _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw",
    closeButton: "_kqswstnw _154iutpp _1xi2utpp _lcxv1wug"
};
const $57d88de957aaaec2$var$SUBTEXT_BY_VARIANT = {
    personalSpace: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerPersonalSpaceSubtext,
    sharedSpace: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerSharedSpaceSubtext,
    liveDoc: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerLiveDocSubtext,
    home: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerHomeSubtext
};
const $57d88de957aaaec2$var$CwrWelcomeBannerContent = ({ isLivePage: isLivePage, variant: variant })=>{
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const firstName = displayName?.split(' ')[0] ?? null;
    (0, $42omo.useEffect)(()=>{
        if (!isDismissed) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'cwrWelcomeBanner',
                attributes: {
                    variant: variant
                }
            }
        }).fire();
         // `variant` is stable per-mount; omitted to avoid a redundant re-fire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDismissed,
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        setIsDismissed(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'cwrWelcomeBanner',
                source: 'viewPageContentContainer',
                attributes: {
                    variant: variant
                }
            }
        }).fire();
        setQueryParams({
            [$57d88de957aaaec2$export$cc62c17e0857f7f7]: undefined
        });
    };
    if (isDismissed) return null;
    const subtextMessage = $57d88de957aaaec2$var$SUBTEXT_BY_VARIANT[variant];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "cwr-welcome-banner",
        className: (0, $gMc0m.default)([
            $57d88de957aaaec2$var$unboundedStyles.root,
            isLivePage && $57d88de957aaaec2$var$unboundedStyles.livePageStyle
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($57d88de957aaaec2$var$styles.contentContainerStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $57d88de957aaaec2$var$unboundedStyles.headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, firstName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerWelcomeMessageWithName,
        values: {
            firstName: firstName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerWelcomeMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $57d88de957aaaec2$var$unboundedStyles.subtextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), subtextMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($57d88de957aaaec2$var$styles.svgContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af279cb6748794c3$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b3fc91056516881a$exports))),
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($57d88de957aaaec2$var$styles.closeButton)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "cwr-welcome-banner-button-close",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage((0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerDismissLabel),
        onClick: handleDismiss
    })));
};
const $57d88de957aaaec2$var$CwrWelcomeBannerInner = ({ contentId: contentId, isLivePage: isLivePage })=>{
    const cwrWelcomeParam = $57d88de957aaaec2$var$useCwrWelcomeParam();
    const isValidBannerRoute = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
    const variant = $57d88de957aaaec2$var$isCwrWelcomeVariant(cwrWelcomeParam) ? cwrWelcomeParam : null;
    const shouldRenderBanner = isValidBannerRoute && !!contentId && variant !== null;
    if (!shouldRenderBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($57d88de957aaaec2$var$CwrWelcomeBannerContent, {
        isLivePage: isLivePage,
        variant: variant
    });
};
const $57d88de957aaaec2$export$fa7cecb87e076447 = ({ contentId: contentId, isLivePage: isLivePage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($57d88de957aaaec2$var$CwrWelcomeBannerInner, {
        contentId: contentId,
        isLivePage: isLivePage
    }));
};
module.exports["CWR_WELCOME_QUERY_PARAM"] = $57d88de957aaaec2$export$cc62c17e0857f7f7;
module.exports["CwrWelcomeBanner"] = $57d88de957aaaec2$export$fa7cecb87e076447;

});


//# sourceMappingURL=CwrWelcomeBanner.9d2b73f9.js.map
